import { makeStyles } from '@material-ui/core/styles';

export const searchStyles = makeStyles((theme) => ({
  wrapper: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  autocomplete: {
    width: '328px',
    '& .MuiInputBase-root.MuiOutlinedInput-root.MuiAutocomplete-inputRoot': {
      padding: theme.spacing(0.125, 2, 0.125, 0.75),
    },
    '& .MuiAutocomplete-popupIndicator': {
      display: 'none',
    },
  },
  option: {
    '&[aria-selected="true"]': {
      backgroundColor: 'transparent',
    },
  },
}));

export const highlighterStyle = makeStyles((theme) => ({
  highlightStyle: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.primary.main,
    padding: theme.spacing(0.5, 0),
    background: 'none',
  },
  parentsStyle: {
    fontSize: theme.typography.subtitle1.fontSize,
    color: theme.palette.text.tertiary,
  },
}));
